import { useCallback } from 'react';

import { distUiGoTo } from '../api/DistUI';

const useRedirectTo = ({ upgradeReturnURL, disableRedirect }) => {
  const redirectTo = useCallback(
    (distUiDest) => {
      if (disableRedirect) return;

      const returnSearchURL = new URLSearchParams(window.location.search).get('returnURL');
      const returnHashURL = new URLSearchParams(window.location.hash.substring(1)).get('returnURL');

      const hrefTo = returnHashURL || returnSearchURL || upgradeReturnURL;

      if (hrefTo) {
        window.location.href = hrefTo;
      } else {
        distUiGoTo(distUiDest);
      }
    },
    [upgradeReturnURL, disableRedirect]
  );

  return redirectTo;
};

export default useRedirectTo;
